import { token, host } from '../../Connnection';
import { IAddSymbols } from '../../../@types/integration/integration.d.tsx'

export default async function patchSymbols(object: IAddSymbols) {
    try {
        let res = await fetch(`${host}/api/PrincipleCheckbox/AddSymbols`, {
            method: 'PATCH',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(object)
        })
        return await res.json();
    } catch (error) {
        console.log(error);
    }
}
